<button type="button" (click)="cancelBtn()" class="ecc-back">&lsaquo; Back to customer</button>

<payarc-page-header title="Edit Card" subtitle="Update the expiry, cardholder name, and billing address for this saved card."></payarc-page-header>

<ng-container *ngIf="topErrorMsg">
  <p class="ecc-top-error" *ngFor="let obj of keys1">
    <ng-container *ngFor="let value of obj">{{value}}</ng-container>
  </p>
</ng-container>
<p class="ecc-top-error" *ngIf="!topErrorMsg && errorMsgFlag && errorMsg">{{errorMsg}}</p>

<payarc-section-card heading="Card on file" class="ecc-section">
  <div class="ecc-card-face">
    <img class="card-img" alt="" [src]="card_img_obj[data.card_brand] ? card_img_obj[data.card_brand] : '../../../../assets/images/card-default.png'"/>
    <div>
      <div class="ecc-card-face__name">{{data.last_four_digits ? '•••• ' + data.last_four_digits : 'Card on file'}}</div>
      <div class="ecc-card-face__meta">The card number cannot be changed once saved.</div>
    </div>
  </div>
</payarc-section-card>

<form #editCard="ngForm">
  <payarc-section-card heading="Expiry" class="ecc-section">
    <payarc-form-field label="Exp. month" controlId="exp_month">
      <select class="pa-input" id="exp_month" name="month" [(ngModel)]="updateCard.exp_month" #month="ngModel">
        <option *ngFor="let month of months" [value]="month.text">{{month.text}}</option>
      </select>
    </payarc-form-field>
    <payarc-form-field label="Exp. year" controlId="exp_year">
      <select class="pa-input" id="exp_year" name="year" [(ngModel)]="updateCard.exp_year" #year="ngModel">
        <option *ngFor="let year of years" [value]="year">{{year}}</option>
      </select>
    </payarc-form-field>
    <payarc-form-field label="Cardholder name" [required]="true" controlId="card_holder_name"
      [error]="editCard.submitted && name.errors?.required ? 'Cardholder name is required.' : (editCard.submitted && name.errors?.maxLength ? 'Cardholder name limit exceed.' : null)">
      <input class="pa-input" type="text" id="card_holder_name" name="name" maxlength="200" required
        #name="ngModel" [(ngModel)]="updateCard.card_holder_name">
    </payarc-form-field>
  </payarc-section-card>

  <payarc-section-card heading="Billing address" class="ecc-section">
    <payarc-form-field label="Address line 1" [required]="addresopt === 0" controlId="street"
      [error]="editCard.submitted && editCard.controls['street']?.errors?.required ? 'Address line 1 is required.' : (editCard.submitted && editCard.controls['street']?.errors?.maxLength ? 'Address line 1 limit exceed.' : null)">
      <div *ngIf="isApiLoaded">
        <input class="pa-input" type="text" id="street" name="street" maxlength="200" [required]="addresopt === 0"
          #street="ngModel" [(ngModel)]="updateCard.address1"
          appPlacesAutocomplete
          [options]="options"
          (onAddressChange)="handleAddressChange($event)">
      </div>
    </payarc-form-field>
    <payarc-form-field label="Address line 2" controlId="street2"
      [error]="editCard.submitted && street2.errors?.maxLength ? 'Address line 2 limit exceed.' : null">
      <input class="pa-input" type="text" id="street2" name="street2" maxlength="200" #street2="ngModel" [(ngModel)]="updateCard.address2">
    </payarc-form-field>
    <payarc-form-field label="City" [required]="addresopt === 0" controlId="city"
      [error]="editCard.submitted && city.errors?.required ? 'City is required.' : null">
      <input class="pa-input" type="text" id="city" name="city" maxlength="200" [required]="addresopt === 0"
        #city="ngModel" [(ngModel)]="updateCard.city">
    </payarc-form-field>
    <payarc-form-field label="Zip code" [required]="addresopt === 0" controlId="zip"
      [error]="editCard.submitted && zip.errors?.maxLength ? 'Zip code limit exceed.' : (editCard.submitted && zip.errors?.required ? 'Zip code is required.' : (editCard.submitted && zip.invalid ? 'Zip format is invalid.' : null))">
      <input class="pa-input" type="text" id="zip" name="zip" maxlength="10" [required]="addresopt === 0"
        #zip="ngModel" [(ngModel)]="updateCard.zip" (keypress)="numericOnly($event)">
    </payarc-form-field>
    <payarc-form-field label="State / Province" [required]="addresopt === 0" controlId="state"
      [error]="editCard.submitted && state.errors?.required ? 'State/Province is required.' : null">
      <select class="pa-input" [required]="addresopt === 0" id="state" name="state" #state="ngModel" [(ngModel)]="updateCard.state">
        <option [value]="null" disabled selected>Choose a state</option>
        <option *ngFor="let state of states" [value]="state.name">{{state.name}}</option>
      </select>
    </payarc-form-field>
    <payarc-form-field label="Country" [required]="addresopt === 0" controlId="country"
      [error]="editCard.submitted && country.errors?.required ? 'Country is required.' : null">
      <select class="pa-input" id="country" name="country" #country="ngModel" [(ngModel)]="updateCard.country" [required]="addresopt === 0">
        <option [value]="null">Choose a country</option>
        <option *ngFor="let country of countries" [value]="country.key">{{country.name}}</option>
      </select>
    </payarc-form-field>
  </payarc-section-card>

  <div class="form-footer">
    <button type="button" payarcButton="secondary" (click)="cancelBtn()">Cancel</button>
    <app-loading-button [loadFlag]="loadFlag" buttonText="Update card" (buttonClick)="editCard.invalid ? null : updateCardFunc()"></app-loading-button>
  </div>
</form>
